module.exports = __webpack_public_path__ + "static/img/KeepNeye.5ced729.png";